import * as angular from 'angular';

import { IRequestService } from '../request.service';

export interface ItagStatisticsService {
    autofit(guidList: string[], beginDate: string, endDate: string): angular.IPromise<{ minimum: number, maximum: number, stdDevThreshold: number }>;
}

export class TagStatisticsService implements ItagStatisticsService {
    static serviceId = 'tagStatisticsService';

    static $inject = ['requestService'];
    constructor(private _requestService: IRequestService) {
    }

    autofit(guidList: string[], beginDate: string, endDate: string): angular.IPromise<{ minimum: number; maximum: number; stdDevThreshold: number }> {
        return this._requestService.postAtV1('tagStatistics/autofit', {
            list: guidList.map(d => {
                return {
                    guid: d,
                    value: ''
                };
            }),
            beginDate: beginDate,
            endDate: endDate
        });
    }
}
